module.exports = __webpack_public_path__ + "img/product_79.8719f56.webp";